import { atom } from "recoil"

export const contactReplyThreadsRequestIdState = atom<number>({
  key: "atoms/contact/contactReplyThreadsRequestIdState",
  default: 0,
})
